export const FieldsInfGral = (data, handleChange, edit, dataBefore) => {
  // const receivedDate = data.fecha_comprobante;
  // const formatedDate = receivedDate.split("/").reverse().join("-");
  return [
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'sucursal',
      label: 'Sucursal',
      optionValue: 'id',
      options: dataBefore.data.sucursal,
      optionLabel: `options["nombre"]`,
      value: data.sucursal,
      disabled: !edit,
      onChange: (e) => handleChange('sucursal', e.id),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'envio',
      label: 'Tipo de envío',
      optionValue: 'id',
      options: dataBefore.data.tipo_envio,
      optionLabel: `options["tipo"]`,
      value: data.envio,
      disabled: !edit,
      onChange: (e) => handleChange('envio', e.id),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'transporte1',
      label: 'Transporte 1',
      optionValue: 'id',
      options: dataBefore.data.transporte_retiro,
      optionLabel: `options["nombre"]`,
      value: data.transporte1,
      disabled: !edit,
      onChange: (e) => handleChange('transporte1', e.id),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'transporte2',
      label: 'Transporte 2',
      optionValue: 'id',
      options: dataBefore.data.transporte_retiro,
      optionLabel: `options["nombre"]`,
      value: data.transporte2,
      disabled: !edit,
      onChange: (e) => handleChange('transporte2', e.id),
    },
    {
      class: 'textfield',
      type: 'number',
      name: 'bultos',
      label: 'Bultos',
      value: data.bultos,
      disabled: !edit,
      sm: 6,
      xs: 12,
      onChange: (e) => {
        handleChange('bultos', e.target.value)
      },
    },
    {
      class: 'textfield',
      name: 'nro_seguimiento',
      label: 'Nº de seguimiento',
      value: data.nro_seguimiento,
      disabled: !edit,
      sm: 6,
      xs: 12,
      onChange: (e) => {
        handleChange('nro_seguimiento', e.target.value)
      },
    },
  ]
}
